// src/components/resumo/annotations/highlightUtils.ts
// 🎯 Utilitários para evitar grifos duplicados

/**
 * Verifica se a seleção cruza com grifos existentes.
 * Usa range.intersectsNode() para checar sobreposição real — evita falsos positivos
 * quando o container pai contém grifos em outros trechos do texto.
 */
export const selectionCrossesHighlight = (selection: Selection): boolean => {
    if (!selection.rangeCount) return false;
    const range = selection.getRangeAt(0);
    const marks = document.querySelectorAll('[data-highlight-id]');
    for (const mark of Array.from(marks)) {
        if (range.intersectsNode(mark)) return true;
    }
    return false;
};

/**
 * Normaliza a seleção para evitar grifos parciais
 */
export const normalizeSelection = (selection: Selection): boolean => {
    if (!selection.rangeCount) return false;

    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;

    // Se a seleção começa ou termina dentro de um grifo, expandir
    let needsNormalization = false;

    // Verificar container inicial
    let node: Node | null = startContainer;
    while (node && node !== document.body) {
        if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node as HTMLElement;
            if (el.hasAttribute('data-highlight-id')) {
                // Expandir para incluir todo o grifo
                range.setStartBefore(el);
                needsNormalization = true;
                break;
            }
        }
        node = node.parentNode;
    }

    // Verificar container final
    node = endContainer;
    while (node && node !== document.body) {
        if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node as HTMLElement;
            if (el.hasAttribute('data-highlight-id')) {
                range.setEndAfter(el);
                needsNormalization = true;
                break;
            }
        }
        node = node.parentNode;
    }

    if (needsNormalization) {
        selection.removeAllRanges();
        selection.addRange(range);
    }

    return needsNormalization;
};